<template>
  <crm-dialog
    :visible="isShowEarnPointsFromBill"
    @update:visible="closeEarnPointsFromBill"
    @close="closeEarnPointsFromBill"
    width="87%"
  >
    <div v-if="!isLoading">
      <div class="circle-points">
        <div class="circle-points circle-1">
          <div class="circle-points circle-2">
            <div class="circle-points circle-3">
              <div class="circle-points-text">
                <div v-if="!isError">
                  <div class="circle-points-number">
                    <h1
                      class="circle-points-main-text"
                      id="points-number-earn"
                      ref="points-number"
                    >
                      {{ numberWithCommas(points == "" ? 0 : points) }}
                    </h1>
                  </div>
                  <p class="circle-points-sub-text">{{ $t('components.history.point') }}</p>
                </div>
                <div v-else>
                  <h1 class="circle-points-main-text">!</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isError">
        <h1 class="main-text">
          {{ $t('components.home.get-points') }} {{ numberWithCommas(points == "" ? 0 : points) }} {{ $t('components.history.point') }}
        </h1>
        <p class="sub-text">
          {{ description }}
        </p>
        <p class="sub-text">
          {{ $t('components.home.remaining') }}
          {{ numberWithCommas(userInfo.point == "" ? 0 : userInfo.point) }}
          {{ $t('components.history.point') }}
        </p>
      </div>
      <div v-else>
        <h1 class="main-text">{{ $t('components.home.cannot-earned') }}</h1>
        <p class="sub-text" v-html="errorMsg"></p>
      </div>
    </div>
    <div v-else>
      <el-skeleton animated style="width: 100%">
        <template #template>
          <div class="d-flex justify-center align-center flex-column">
            <el-skeleton-item
              variant="circle"
              style="width: 144px; height: 144px"
              class="ma-4"
            />
            <el-skeleton-item variant="h1" class="mt-3" style="width: 50%" />
            <el-skeleton-item
              variant="p"
              class="mt-2 mb-4"
              style="width: 40%"
            />
          </div>
        </template>
      </el-skeleton>
    </div>
    <template #footer class="dialog-footer">
      <el-button
        :disabled="isLoading"
        class="ok-btn"
        type="primary"
        @click="gotoReviewfeedBack"
        >{{ $t('components.change-phone.ok') }}</el-button
      >
    </template>
  </crm-dialog>
</template>

<script>
import CrmDialog from "@/components/Dialog";
import { mapActions, mapGetters, mapMutations } from "vuex";
import mixins from "@/helper/mixins";
import GATracking from "@/helper/GATrackingMixins";

export default {
  name: "EarnPointsFromBill",
  mixins: [mixins, GATracking],
  components: {
    CrmDialog,
  },
  data() {
    return {
      isLoading: false,
      points: 0,
      isError: null,
      registerPoints: null,
      register: false,
      haveuUoc: false,
      earnPoints: 0,
      description:'',
    };
  },
  computed: {
    ...mapGetters({
      isShowEarnPointsFromBill: "bill/isShowEarnPointsFromBill",
      userInfo: "user/userInfo",
      uniqueOrderCodeFeedback : 'feedback/uniqueOrderCode',
      branchUUID: 'branch/branchUUID',
      uniqueOrderCode: "bill/uniqueOrderCode",
    }),
    errorMsg() {
      switch (this.isError.code) {
        case 404:
          return this.$t('components.home.not-found');
        case 400:
          return this.$t('components.home.already-been-awarded')+"<br/>"+this.$t('components.home.if-in-doubt');
        default:
          return this.$t('components.home.error-earning');
      }
    },
  },
  async mounted() {
    const dataPointsString = localStorage.getItem('register-points')
    this.registerPoints = dataPointsString ? JSON.parse(dataPointsString) : null
    this.register = dataPointsString ? true : false
    this.haveuUoc = this.uniqueOrderCode ? true : false
    this.setBranchFeedback(this.branchUUID)
    if(dataPointsString){
      this.points = this.registerPoints.point || 0
      localStorage.removeItem('register-points')
    }
    this.setDescription()
    if(this.haveuUoc)
      this.earnPointsFromBill();
  },
  updated() {
    this.resizeFontToFit();
  },
  methods: {
    ...mapActions({
      earnPointsFromBillAction: "bill/earnPointsFromBill",
      fetchUserInfo: "user/fetchUserInfo",
    }),
    ...mapMutations({
      closeEarnPointsFromBill: "bill/CLOSE_EARN_BILL_DIALOG",
      setUserPoints: "user/SET_POINT",
      setUoc: "bill/SET_UOC",
      setBranchFeedback: "feedback/SET_BRANCH",
      setIcon: "feedback/SET_ICON"
    }),
    async earnPointsFromBill() {
      this.isLoading = true;
      await this.earnPointsFromBillAction()
        .then((response) => {
          this.isError = null;
          this.isLoading = false;
          const data = response.data.data;
          this.earnData = data;
          this.earnPoints = data.paymentList[0].point;
          this.points += data.paymentList[0].point;
          this.setUserPoints(data.memberPoint);
          this.setUoc({
            uoc: null,
            points: null,
          });
          this.$router.replace({ query: null });
          if(response.data.code == 200 && response.data.message.includes('Temp point history')) {
            this.$store.commit("feedback/SET_UOC", null)
          }
        })
        .catch(async (error) => {
          if (error.response) {
            this.$store.commit("feedback/SET_UOC", null)
            if (error.response.status < 500) {
              this.isLoading = false;
              this.isError = error.response.data;
            } else {
              this.isError = { code: 5 };
              await this.$alert(this.$t('login.error-try-connect'), "", {
                confirmButtonText: this.$t('login.try-again'),
                center: true,
              }).finally(() => {
                this.earnPointsFromBill();
              });
            }
          } else {
            this.isLoading = false;
            await this.$alert(this.$t('components.home.error-occurred'), "", {
              confirmButtonText: this.$t('login.try-again'),
              center: true,
            });
          }
        })
        .finally(() => {});
    },
    resizeFontToFit() {
      const element = this.$refs["points-number"];
      if (element) {
        switch (element.textContent.trim().length) {
          case 5: // X,XXX
            element.style.fontSize = "34px";
            break;
          case 6: // XX,XXX
            element.style.fontSize = "28px";
            break;
          case 7: // XXX,XXX
            element.style.fontSize = "24px";
            break;
          case 9: // X,XXX,XXX
            element.style.fontSize = "19px";
            break;
          case 10: // XX,XXX,XXX
            element.style.fontSize = "17px";
            break;
          default:
            element.style.fontSize = "52px";
            break;
        }
      }
    },
    gotoReviewfeedBack(){
      this.closeEarnPointsFromBill()
      if(this.haveuUoc){
        this.trackFeedback(1, 'CRMFeedback');
        this.setIcon(false)
        this.fetchUserInfo().then(async (response) => {
          if( response.feedback.uoc == this.uniqueOrderCodeFeedback  ){
            localStorage.setItem('feedback-round', 1)
            localStorage.setItem('crm-review-feedback', this.uniqueOrderCodeFeedback)
          }
        });
        if(!this.isError && this.uniqueOrderCodeFeedback){ 
          this.$router.push({
            name:'feedback',
            params:{uoc:this.uniqueOrderCodeFeedback}
          })
        }
      }
      
    },
    setDescription(){
      this.description = this.$t('components.points.form')
      if(this.register && this.haveuUoc) {
        this.description += `${ this.$t('components.points.first-time-regis')} ${ this.$t('components.points.and')} ${ this.$t('components.points.total-bill-spent')} `
      }else if(this.register) {
        this.description += `${ this.$t('components.points.first-time-regis')}`
      }else if(this.haveuUoc) {
        this.description += `${ this.$t('components.points.total-bill-spent')}`
      }
    }
  }
};
</script>

<style>
.circle-points {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin: 16px;
}
.circle-1 {
  background-color: rgba(
    var(--primary-r),
    var(--primary-g),
    var(--primary-b),
    0.1
  );
  width: 144px;
  height: 144px;
}
.circle-2 {
  background-color: rgba(
    var(--primary-r),
    var(--primary-g),
    var(--primary-b),
    0.2
  );
  width: 112px;
  height: 112px;
}
.circle-3 {
  background-color: var(--primary);
  opacity: 1;
  width: 80px;
  height: 80px;
}
.circle-points-text {
  display: flex;
  flex-direction: column;
}
.circle-points-number {
  position: relative;
  width: 60px;
  height: 32px;
}
.circle-points-main-text {
  margin: 0;
  color: white;
  font-size: 52px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: center;
}
.circle-points-sub-text {
  margin: 0;
  color: white;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
}

.main-text {
  margin: 0;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: center;
}
.sub-text {
  margin: 0;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
}

.ok-btn {
  width: 100%;
}

.resizeme {
  resize: both;
  margin: 0;
  padding: 0;
  height: 75px;
  width: 500px;
  background-color: lightblue;
  overflow: hidden;
}
</style>